/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import App from '../LservApp.vue';
import CommercialLicensesView from '@/views/licenses/commercial/CommercialLicensesView.vue';
import UnauthorizedUserPage from '@/shell/UnauthorizedUserPage.vue';
import AppLoader from '@/shell/AppLoader.vue';

Vue.use(VueRouter);

export enum MainRoute {
  EVALUATIONS = 'evaluations',
  LICENSES = 'licenses',
  REPORTS = 'reports',
  PRODUCTS = 'products'
}

/**
 * Possible subpaths under the 'evaluations' route.
 */
export enum EvaluationsSubroute {
  ACTIVE = 'active',
  EXPIRED = 'expired'
}

/**
 * Possible subpaths under the 'evaluations' route.
 */
export enum LicensesSubroute {
  COMMERCIAL = 'commercial',
  OPEN_SOURCE = 'open-source',
  ACADEMIC = 'academic',
  DEMO = 'demo',
  REVOKED = 'revoked'
}

/**
 * Possible subpaths under the `licenses/open-source` route.
 */
export enum OpenSourceSubroute {
  REQUESTS = 'requests',
  LICENSES = 'licenses'
}

/**
 * Possible subpaths under the `licenses/open-source` route.
 */
export enum AcademicLicensesSubroute {
  REQUESTS = 'requests',
  LICENSES = 'licenses',
  EXPIRED = 'expired'
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    components: {
      default: App,
      loader: AppLoader,
      unauthorized: UnauthorizedUserPage,
    },
    redirect: `/${MainRoute.EVALUATIONS}/${EvaluationsSubroute.ACTIVE}`,
    children: [
      {
        path: `${MainRoute.EVALUATIONS}/${EvaluationsSubroute.ACTIVE}`,
        component: CommercialLicensesView,
        // component: ActiveEvaluationsView // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready.
      }, {
        path: `${MainRoute.EVALUATIONS}/${EvaluationsSubroute.ACTIVE}/:uuid`,
        component: CommercialLicensesView,
        // component: ActiveEvaluationsView // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready.
      }, {
        path: `${MainRoute.EVALUATIONS}/${EvaluationsSubroute.EXPIRED}`,
        component: CommercialLicensesView,
        // component: ExpiredEvaluationsView // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready.
      }, {
        path: `${MainRoute.EVALUATIONS}/${EvaluationsSubroute.EXPIRED}/:uuid`,
        component: CommercialLicensesView,
        // component: ExpiredEvaluationsView // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready.
      }, {
        path: `${MainRoute.LICENSES}/${LicensesSubroute.COMMERCIAL}`,
        component: CommercialLicensesView
      }, {
        path: `${MainRoute.LICENSES}/${LicensesSubroute.COMMERCIAL}/:uuid`,
        component: CommercialLicensesView
      }, {
        path: `${MainRoute.LICENSES}/${LicensesSubroute.OPEN_SOURCE}/`,
        component: CommercialLicensesView,
        // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
        // component: OpenSourceLicensesView,
        // redirect: `/${MainRoute.LICENSES}/${LicensesSubroute.OPEN_SOURCE}/${OpenSourceSubroute.REQUESTS}`,
        children: [
          {
            path: OpenSourceSubroute.REQUESTS,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: OpenSourceRequestsSubview,
          }, {
            path: `${OpenSourceSubroute.REQUESTS}/:uuid`,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: OpenSourceRequestsSubview,
          }, {
            path: OpenSourceSubroute.LICENSES,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: OpenSourceLicensesSubview
          }, {
            path: `${OpenSourceSubroute.LICENSES}/:uuid`,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: OpenSourceLicensesSubview
          }
        ]
      }, {
        path: `${MainRoute.LICENSES}/${LicensesSubroute.ACADEMIC}`,
        component: CommercialLicensesView,
        // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
        // component: AcademicLicensesView,
        // redirect: `/${MainRoute.LICENSES}/${LicensesSubroute.ACADEMIC}/${AcademicLicensesSubroute.REQUESTS}`,
        children: [
          {
            path: AcademicLicensesSubroute.REQUESTS,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: AcademicRequestsSubview,
          }, {
            path: `${AcademicLicensesSubroute.REQUESTS}/:uuid`,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: AcademicRequestsSubview,
          }, {
            path: AcademicLicensesSubroute.LICENSES,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: AcademicLicensesSubview
          }, {
            path: `${AcademicLicensesSubroute.LICENSES}/:uuid`,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: AcademicLicensesSubview
          }, {
            path: AcademicLicensesSubroute.EXPIRED,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: ExpiredAcademicLicensesSubview
          }, {
            path: `${AcademicLicensesSubroute.EXPIRED}/:uuid`,
            component: CommercialLicensesView,
            // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
            // component: ExpiredAcademicLicensesSubview
          }
        ]
      }, {
        path: `${MainRoute.LICENSES}/${LicensesSubroute.DEMO}`,
        component: CommercialLicensesView,
        // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
        // component: DemoLicensesView
      }, {
        path: `${MainRoute.LICENSES}/${LicensesSubroute.DEMO}/:uuid`,
        component: CommercialLicensesView,
        // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
        // component: DemoLicensesView
      }, {
        path: `${MainRoute.LICENSES}/${LicensesSubroute.REVOKED}`,
        component: CommercialLicensesView,
        // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
        // component: RevokedLicensesView
      }, {
        path: `${MainRoute.LICENSES}/${LicensesSubroute.REVOKED}/:uuid`,
        component: CommercialLicensesView,
        // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
        // component: RevokedLicensesView
      }, {
        path: MainRoute.REPORTS,
        component: CommercialLicensesView,
        // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
        // component: ReportsView
      }, {
        path: MainRoute.PRODUCTS,
        component: CommercialLicensesView,
        // TODO:29.10.2022:yehor.pytomets:ls-spine-model: Uncomment when ready
        // component: ProductsView
      },
    ]
  }, {
    // redirect to a default home page on all unrecognized URLs
    path: '*',
    redirect: '/'
  }
];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
